<template>
  <div class="wrapper">
    <h1>Oops! That page doesn't exist ...</h1>
  </div>
</template>

<style scoped>
.wrapper {
  display: flex;
  justify-content: center;
}
</style>
